import React from 'react';
import {
  Typography, Box, alpha, useTheme,
} from '@mui/material';
import { postMemberPreLoanRequest } from '../../../queries/preloan';
import heroImg from '../../../assets/advance_offer_hero.jpg';
import bancameLogo from '../../../assets/bancame_logo_white.svg';
import HeroCard from '../../../components/HeroCard';
import analytics from '../../../utils/analytics';

type AdvanceRequestCardProps = {
  token: string;
  origin?: string;
  variant?: 'default' | 'inline';
  currentPlrStep?: string;
};

export default function AdvanceRequestCard({
  token, origin, variant, currentPlrStep,
}: AdvanceRequestCardProps) {
  const theme = useTheme();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const handleRequest = async () => {
    setLoading(true);
    setError(false);
    try {
      const res = await postMemberPreLoanRequest(token, origin);
      analytics.page('PU - TU CREDITO', 'REDIRECCION AVANCE');
      window.location.assign(res.data.url);
    } catch {
      setLoading(false);
      setError(true);
    }
  };

  const isInline = variant === 'inline';
  const hasCurrentPlrStep = currentPlrStep && currentPlrStep !== 'NEEDS_CU';

  return (
    <HeroCard
      heroImage={heroImg}
      loading={loading}
      error={error}
      onConfirm={handleRequest}
      buttonText={hasCurrentPlrStep ? 'Continuar solicitud de avance' : 'Solicitar avance'}
      variant={isInline ? 'inline' : 'default'}
      logo={!isInline ? (
        <Box
          component="img"
          src={bancameLogo}
          alt="banca.me"
          sx={{
            height: 15, width: 'auto', display: 'block', mb: 2.5,
          }}
        />
      ) : <Box />}
      title={(
        <Typography
          variant="h5"
          sx={{
            fontWeight: 800,
            letterSpacing: '-0.8px',
            lineHeight: 1.1,
            color: '#fff',
          }}
        >
          Tu crédito, a tu medida
        </Typography>
      )}
      body={(
        <Typography
          variant="body2"
          sx={{
            lineHeight: 1.5,
            color: alpha(theme.palette.white.main, 0.8),
            maxWidth: { xs: '100%', md: isInline ? '95%' : '70%' },
          }}
        >
          {hasCurrentPlrStep ? (
            <b>
              Continúa con tu solicitud de avance,
              {' '}
            </b>
          ) : (
            <span>
              Evalúate en 2 minutos, elige tu monto y tus cuotas,
              {' '}
            </span>
          )}
          {' '}
          <span>
            y en menos de 24 horas tendrás el dinero en tu cuenta.
          </span>
        </Typography>
      )}
    />
  );
}

AdvanceRequestCard.defaultProps = {
  origin: 'portal-usuario',
  variant: 'default',
  currentPlrStep: null,
};
